import styled from "@emotion/styled";

export const WrapperRoot = styled.div`
  padding: 0;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    padding: 0 ${p => p.theme.space[6]}px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 48px 0;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    gap: 28px;
    padding: 0;
  }
`;

export const ArticleWrapper = styled.div`
  display: block;

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    display: none;
  }
`;

export const BlogSection = styled.section`
  p,
  ul,
  ol {
    margin-bottom: 20px;

    font-size: 16px;
    color: ${({ theme }) => theme.colors.secondary.gray};
    line-height: 2;

    @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      margin-bottom: 28px;

      font-size: ${({ theme }) => theme.fontSizes.m};
      line-height: 1.8;
    }
  }

  h2,
  h3 {
    margin-top: 20px;
    margin-bottom: 20px;

    font-size: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    line-height: 1.25;

    color: ${({ theme }) => theme.colors.secondary.title};

    @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      margin-top: 28px;
      margin-bottom: 28px;

      font-size: ${({ theme }) => theme.fontSizes.xxl};
    }
  }

  ul {
    li {
      margin-left: 28px;

      list-style-type: disc;
    }
  }

  ol {
    li {
      margin-left: 28px;
      padding-left: ${({ theme }) => theme.space[2]}px;

      list-style-type: decimal;
    }
  }

  .info {
    display: none;
    flex-direction: column;
    padding: ${p => p.theme.space[6]}px;
    margin-bottom: 28px;
    gap: ${({ theme }) => theme.space[5]}px;

    background-color: ${({ theme }) => theme.colors.accent.green};
    border-radius: 20px;

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      display: flex;
      flex-direction: row;
    }
  }

  .icon {
    max-width: 20px;
    height: 20px;
    width: 100%;
    margin-bottom: 0;
    margin-top: 3px;

    background-image: url("/assets/images/info.svg");
    background-repeat: no-repeat;
  }

  .text {
    display: flex;
    flex-direction: column;
    max-width: 519px;

    h2 {
      margin-top: 0;
      margin-bottom: ${p => p.theme.space[4]}px;
      font-size: 22px;
      font-weight: ${p => p.theme.fontWeight.medium};
      line-height: 1.25;
    }
    p {
      margin-bottom: 0;
    }
  }

  .link {
    width: auto;
    height: 48px;
    margin-left: auto;
    padding: 12px 14px;
    align-self: center;

    background-color: ${({ theme }) => theme.colors.white};
    text-decoration: none;

    font-size: 18px;
    line-height: 1.33;
    color: ${({ theme }) => theme.colors.black};

    border-radius: 12px;
    white-space: nowrap;
    transition: background-color 0.3s ease-in-out;

    -webkit-tap-highlight-color: transparent;

    :hover {
      background-color: ${({ theme }) => theme.colors.buttonHover};
    }

    :active {
      background-color: ${({ theme }) => theme.colors.buttonActive};
    }
  }

  table {
    display: none;

    @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
      display: block;
      max-width: 100%;
      width: fit-content;
      overflow: auto;

      font-size: 14px;
      line-height: 1.5;

      border: 1px solid #edeff2;
      border-radius: ${p => p.theme.radii.medium};
      border-collapse: collapse !important;
      background-color: #fff;
    }

    th {
      min-width: 114px;
      padding: 12px;
      font-size: 14px;
      font-weight: ${({ theme }) => theme.fontWeight.semiBold};
      line-height: 1.42;

      text-align: start;
    }

    tbody {
      th:first-of-type,
      td:first-of-type {
        min-width: 160px;
      }
      tr {
        :not(:last-child) {
          border-bottom: 1px solid #edeff2;
        }
      }

      td {
        min-width: 114px;
        padding: 14px 12px;
      }
    }
  }

  .true-value {
    display: block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.accent.green};
    background-image: url("/assets/svg/true-icon.svg");
    background-repeat: no-repeat;
    background-position: center;
  }

  .false-value {
    display: block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.background};
    background-image: url("/assets/svg/false-icon.svg");
    background-repeat: no-repeat;
    background-position: center;
  }
`;
